export const promisify = (resolved: boolean): Promise<void> => {
    return new Promise((resolve) => {
        if (resolved) {
            resolve();
        }
    });
};

export const downloadFile = (path: string, isFullPath?: boolean): void => {
    const link = document.createElement('a');

    link.href = isFullPath
        ? path
        : `${window.location.origin}/${path[0] === '/' ? path.slice(1) : path}?t=${Date.now()}`;

    const filename = path.split('/').pop();

    link.setAttribute('download', filename!);
    document.body.appendChild(link);
    link.click();
    link.parentNode!.removeChild(link);
};

export const convertToSelectFormat = (inputData: any[], labelFieldName = 'label', valueFieldName = 'id'): any[] => {
    const newInputData = [...inputData];

    newInputData.forEach((dataItem: any, dataIndex: any) => {
        newInputData[dataIndex].label = dataItem[labelFieldName];
        newInputData[dataIndex].value = dataItem[valueFieldName];
    });
    return newInputData;
};

export const stripHtml = (originalString?: string | null): string =>
    originalString ? originalString.replace(/(<([^>]+)>)/gi, '').trim() : '';
